import React from 'react';
import { useParams } from 'react-router-dom';
import ReportViewContainer from '../../containers/report/ReportViewContainer';

const ReportViewPage = () => {
  const { id } = useParams();
  return <ReportViewContainer rptUuid={id} />;
};

export default ReportViewPage;
